export default __webpack_public_path__ + "static/media/menu2.4331ada7.svg";